"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Cookie = /** @class */ (function () {
    function Cookie() {
    }
    Cookie.get = function (name) {
        var data = ("; " + document.cookie).split("; " + name + "=");
        return data && data.length === 2 ? ((data.pop() || '').split(';').shift()) : (null);
    };
    Cookie.set = function (name, value, expires) {
        document.cookie = name + "=" + value + "; expires=" + expires.toUTCString() + "; path=/";
    };
    return Cookie;
}());
exports.Cookie = Cookie;
//# sourceMappingURL=Cookie.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ckies/library/dist/lib/Cookie.js
// module id = 657
// module chunks = 193 194 199